// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.u_hOWuesh0JTwPraFh8V{height:50vh;display:flex;flex-direction:column;align-items:center;justify-content:center}`, "",{"version":3,"sources":["webpack://./src/App/components/Loading/Loading.module.scss"],"names":[],"mappings":"AAAA,sBAAS,WAAW,CAAC,YAAY,CAAC,qBAAqB,CAAC,kBAAkB,CAAC,sBAAsB","sourcesContent":[".loading{height:50vh;display:flex;flex-direction:column;align-items:center;justify-content:center}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading": `u_hOWuesh0JTwPraFh8V`
};
export default ___CSS_LOADER_EXPORT___;
